<template src="./ListClinics.html"></template>
<script>
import Clinic from "../Clinic/Clinic.vue";
export default {
  name: "list-clinics",
  components: {
    Clinic
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      showAwaitingApprovalWebTable: true,
      showRegisteredClinics: true,
      showTabs: true,
      mainAttendance: [],
      showClinic: false,
      clinicsPendingApproval: [],
      clinics: [],
      clinicId: null,
      indexActive: 0
    };
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted() {
    const vm = this;
    vm.indexActive = 1;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getClinicDoctorsPendingApproval();
      vm.getClinics();
    },
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width <= 670) {
        vm.showAwaitingApprovalWebTable = false;
        vm.showRegisteredClinics = false;
        vm.showTabs = false;
      } else {
        vm.showAwaitingApprovalWebTable = true;
        vm.showRegisteredClinics = true;
        vm.showTabs = true;
      }
    },
    acceptClinic(id, clinic) {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "doctor/clinic-doctors/" +
            id +
            "/accept-clinic"
        )
        vm.$swal({
              title: "Sucesso!",
              text:
                "A clínica " +
                clinic.socialName +
                " foi aceita com sucesso",
              icon: "success"
            })
        vm.getClinicDoctorsPendingApproval();
        vm.getClinics();
    },
    removeClinic(id, clinic) {
      const vm = this;
      vm.axios
        .delete(vm.$store.state.filooServer + "doctor/clinics/" + id, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        vm.$swal({
              title: "Sucesso!",
              text:
                "A clínica " +
                clinic.webClinic.name +
                " foi aceita com sucesso",
              icon: "success"
            })
        vm.getClinicDoctorsPendingApproval();
        vm.getClinics();
       
    },
    defineMainAttendanceClinic(idClinic, index, clinic, nameClinic) {
      const vm = this;
      if (vm.mainAttendance[index] === true) {
        vm.$refs.MainAttendanceClinic.value = false;
      } else {
        vm.$refs.MainAttendanceClinic.value = true;
      }

      if (vm.$refs.MainAttendanceClinic.value === true) {
        vm.axios
          .put(
            vm.$store.state.filooServer +
              "doctor/clinic-doctors/" +
              idClinic +
              "/main-attendance",
            clinic,
            {
              headers: { Authorization: vm.$session.get("bearer") }
            }
          )
          .then(function(response) {
            if (response.status === 200) {
              vm.$swal({
                title: "Sucesso!",
                text:
                  "A " +
                  nameClinic +
                  "foi definida com sucesso como clínica padrão.",
                icon: "success"
              }).then(function() {
                vm.getClinics();
              });
            }
          });
      }
    },
    addNewClinic() {
      const vm = this;
      vm.showClinic = true;
    },
    getClinicDoctorsPendingApproval() {
      const vm = this;

      vm.axios
        .get(
          vm.$store.state.filooServer +
            "doctor/clinic-doctors/pending-approval",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.clinicsPendingApproval = response.data.content;
          }
        });
    },
    editClinic(idClinic) {
      const vm = this;
      vm.clinicId = idClinic;
      vm.showClinic = true;
    },
    getClinics() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "doctor/clinic-doctors", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.clinics = response.data.content;
            var i = 0;
            for (i = 0; i < vm.clinics.length; i++) {
              vm.mainAttendance[i] = vm.clinics[i].mainAttendance;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss" src="./ListClinics.scss">
</style>